import { AvailableService } from '../services/Appointment/model';

export const getService = (
  serviceId: string,
  services: AvailableService[] = [],
): AvailableService | undefined => {
  const currentService = services.find(
    (s: AvailableService): boolean => s.serviceId === serviceId,
  );

  return currentService;
};
